import React, { useEffect, useState } from 'react';
import axios from 'axios';
import Box from '@mui/material/Box';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import PageLayout from '../../components/layout/PageLayout';
import DataTable from '../../components/ui/DataTable';
import StatusChip from '../../components/ui/StatusChip';
import ActionIconButton from '../../components/ui/ActionIconButton';
import { notify } from '../../components/feedback/notify';
import { FormatDate } from "../../utils/FormatDate";
import { statusAssinatura } from "../../utils/StatusAssinatura";

function Assinaturas() {
    const token = localStorage.getItem('token');
    const [assinaturas, setAssinaturas] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const getAssinaturas = async () => {
            try {
                const response = await axios.get(`${process.env.REACT_APP_API_URL}/listarAssinaturas`, {
                    headers: {
                        Authorization: token
                    }
                });
                setAssinaturas(response.data.assinaturas || []);
            } catch (error) {
                console.error("Erro ao listar assinaturas:", error);
                notify.error("Não foi possível carregar as assinaturas.");
            } finally {
                setLoading(false);
            }
        };
        getAssinaturas();
    }, [token]);

    const columns = [
        { key: 'idAssinatura', label: 'ID', width: 72 },
        { key: 'cliente', label: 'Cliente', sx: { fontWeight: 500 }, render: (a) => a?.usuario?.Nome || '—' },
        { key: 'plano', label: 'Plano', render: (a) => a?.Plano?.nome || '—' },
        { key: 'dataInicio', label: 'Início', render: (a) => (a?.dataInicio ? FormatDate(a.dataInicio) : '—') },
        { key: 'proximaCobranca', label: 'Próxima cobrança', render: (a) => (a?.proximaCobranca ? FormatDate(a.proximaCobranca) : '—') },
        {
            key: 'status',
            label: 'Status',
            render: (a) => {
                const s = statusAssinatura(a?.status);
                return <StatusChip label={s.label} tone={s.tone} />;
            },
        },
        {
            key: 'acoes',
            label: 'Ações',
            align: 'right',
            width: 110,
            render: () => (
                <Box sx={{ display: 'inline-flex', gap: 0.75 }}>
                    <ActionIconButton title="Editar" icon={<EditOutlinedIcon fontSize="small" />} pending />
                    <ActionIconButton title="Excluir" color="error" icon={<DeleteOutlineIcon fontSize="small" />} pending />
                </Box>
            ),
        },
    ];

    return (
        <PageLayout
            title="Assinaturas"
            subtitle="Planos contratados pelos clientes e próximas cobranças."
            breadcrumbs={[{ label: 'Dashboard', to: '/dashboard' }, { label: 'Assinaturas' }]}
        >
            <DataTable
                columns={columns}
                rows={assinaturas}
                getRowKey={(a, i) => a?.idAssinatura ?? i}
                loading={loading}
                emptyMessage="Nenhuma assinatura encontrada."
            />
        </PageLayout>
    );
}

export default Assinaturas;
